export default __webpack_public_path__ + "static/media/menu_company_icon.83b11ffb.svg";